import React from "react"

import SEO from "@components/seo"
import Container from "@components/container"
import EventTime from "@components/eventTime"
import GameTabs from "@components/gameTabs"
import Sfv from "@components/pages/season4/sfv"
import Mk8 from "@components/pages/season4/mk8"
import SuperSmashBros from "@components/pages/season4/superSmashBros"

// import mk8Logo from "@images/mk8.png"
import sfvLogo from "@images/sfv.png"
import superSmashBrosLogo from "@images/ssb.png"

const Season1 = () => {
  return (
    <>
      <SEO title="SEASON 4" />
      <EventTime enroll="12.14 ~ 12.31" start="1.16 ~ 1.30" />
      <Container>
        <GameTabs
          games={[
            {
              key: "superSmashBros",
              title: "任天堂明星大乱斗 特别版",
              logo: superSmashBrosLogo,
            },
            { key: "sfv", title: "街头霸王5 冠军版", logo: sfvLogo },
            // {
            //   key: "mk8",
            //   title: "马力欧卡丁车8 豪华版（国行版）",
            //   logo: mk8Logo,
            // },
          ]}
        >
          {key => {
            if (key === "sfv") {
              return <Sfv />
            // } else if (key === "mk8") {
            //   return <Mk8 />
            } else if (key === "superSmashBros") {
              return <SuperSmashBros />
            }
          }}
        </GameTabs>
      </Container>
    </>
  )
}

export default Season1
